import React from "react";
import styled from "styled-components";
import { Loading } from "../../../components";
import useMatches from "../hooks/useMatches";
import useClanInfo from "../hooks/useClanInfo";
import PlayerInfo from "./PlayerInfo";
import MatchHistory from "./MatchHistory";
import Aoe2Links from "./Aoe2Links";

const PlayerProfileCard = ({
  playerId,
  tournamentId,
  player,
  loadingPlayer,
  errorPlayer,
}) => {
  const {
    matches,
    loading: loadingMatches,
    error: errorMatches,
  } = useMatches(playerId, tournamentId);
  const { clanInfo, loading: loadingClan } = useClanInfo(player);

  if (loadingPlayer)
    return (
      <LoadingWrapper>
        <Loading />
      </LoadingWrapper>
    );
  if (errorPlayer || !player)
    return <ErrorCard>Error cargando la info del jugador</ErrorCard>;

  return (
    <Card>
      <PlayerInfo
        player={player}
        clanInfo={clanInfo}
        loadingClan={loadingClan}
      />
      <MatchHistory
        matches={matches}
        loading={loadingMatches}
        error={errorMatches}
        playerId={playerId}
      />
      <Aoe2Links player={player} />
    </Card>
  );
};

const Card = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 1.25rem;
  margin-bottom: 1rem;
`;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
`;

const ErrorCard = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 1.25rem;
  margin-bottom: 1rem;
  font-family: var(--v-font-body);
  font-size: 13px;
  color: var(--v-fg-muted);
  text-align: center;
`;

export default PlayerProfileCard;
